var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewBackgroundMobile(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 485,
    viewBox: "0 0 375 485",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_768_7347)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 20,
    width: 316,
    height: 405,
    rx: 40,
    fill: "#FFE3B0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.776 34.4683C102.771 35.4373 103.596 36.192 104.62 36.1539C105.644 36.1158 106.478 35.2994 106.483 34.3303C106.488 33.3613 105.662 32.6066 104.638 32.6447C103.614 32.6828 102.781 33.4992 102.776 34.4683Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8541 121.556C62.8506 122.24 63.4336 122.773 64.1563 122.746C64.879 122.719 65.4677 122.143 65.4712 121.459C65.4748 120.775 64.8918 120.242 64.1691 120.269C63.4464 120.296 62.8576 120.872 62.8541 121.556Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7469 71.1799C79.7419 72.149 80.5677 72.9037 81.5915 72.8656C82.6152 72.8275 83.4491 72.011 83.4541 71.042C83.4591 70.0729 82.6333 69.3182 81.6096 69.3563C80.5858 69.3944 79.7519 70.2109 79.7469 71.1799Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.918 74.039C97.9157 74.495 98.3043 74.8501 98.7862 74.8322C99.268 74.8142 99.6605 74.43 99.6628 73.9741C99.6652 73.5181 99.2765 73.163 98.7947 73.1809C98.3129 73.1988 97.9204 73.583 97.918 74.039Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174.437 36.0793C174.434 36.5353 174.823 36.8904 175.305 36.8724C175.787 36.8545 176.179 36.4703 176.181 36.0143C176.184 35.5584 175.795 35.2033 175.313 35.2212C174.831 35.2391 174.439 35.6233 174.437 36.0793Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3974 82.8228C49.3924 83.7918 50.2183 84.5465 51.242 84.5084C52.2657 84.4703 53.0997 83.6539 53.1047 82.6848C53.1097 81.7158 52.2839 80.9611 51.2601 80.9991C50.2364 81.0372 49.4024 81.8537 49.3974 82.8228Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.715 49.5613L98.4069 53.4337",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M203.292 50.2808L200.045 46.7896",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8098 41.6466L54.9518 39.4388",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.274 148.463L41.0655 152.061",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M151.157 36.0073L149.847 40.6993",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0593 108.751L79.853 105.508",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M281.913 408.697C281.901 407.813 281.133 407.143 280.197 407.199C279.261 407.256 278.512 408.018 278.524 408.902C278.535 409.785 279.303 410.456 280.239 410.4C281.175 410.343 281.925 409.581 281.913 408.697Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M316.827 328.317C316.819 327.693 316.276 327.22 315.616 327.26C314.955 327.299 314.426 327.837 314.434 328.461C314.442 329.085 314.984 329.558 315.645 329.518C316.306 329.478 316.835 328.941 316.827 328.317Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M216.344 408.541C216.338 408.125 215.977 407.81 215.536 407.836C215.096 407.863 214.743 408.221 214.748 408.637C214.754 409.053 215.115 409.369 215.556 409.342C215.996 409.316 216.349 408.957 216.344 408.541Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M329.844 363.494C329.833 362.61 329.065 361.939 328.129 361.996C327.193 362.052 326.443 362.814 326.455 363.698C326.467 364.582 327.235 365.253 328.171 365.196C329.107 365.14 329.856 364.378 329.844 363.494Z",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M281.685 394.897L285.564 391.275",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M189.69 396.089L192.726 399.214",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M320.162 401.374L325.56 403.274",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M331.492 303.407L336.199 300.02",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M237.628 408.182L238.753 403.866",
    stroke: "#8F6F6F",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_768_7347",
    x: -11,
    y: 0,
    width: 396,
    height: 485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_768_7347"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_768_7347",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewBackgroundMobile);
export default __webpack_public_path__ + "static/media/ReviewBackgroundMobile.b49647952283472da3a44eb800d3698c.svg";
export { ForwardRef as ReactComponent };